/** Pendant zu `Services/API/ApiCategorieService.cs`. */

import type { ChinaAppSysGroupCategory } from '@/types/entities';

import {
  buildAppPath,
  createCrudApi,
  requestOrFallback,
  requestSucceeded,
  type CrudApi,
} from '../apiBase';
import { apiClient } from '../httpClient';

const ENDPOINT = 'categories';

export const categoryApi: CrudApi<ChinaAppSysGroupCategory> & {
  getMy(): Promise<ChinaAppSysGroupCategory[]>;
  addView(id: number, viewId: number): Promise<boolean>;
  removeView(id: number, viewId: number): Promise<boolean>;
} = {
  ...createCrudApi<ChinaAppSysGroupCategory>(ENDPOINT),

  getMy: () =>
    requestOrFallback(
      () => apiClient.get<ChinaAppSysGroupCategory[]>(`${buildAppPath(ENDPOINT)}/my`),
      [],
    ),

  /**
   * Die Route nimmt keinen Rumpf. Sie antwortet mit 400, wenn die View schon zu einer
   * Kategorie gehört (`vie.CategoryId != null`) — angeboten werden deshalb nur Views ohne
   * Kategorie (REQ-28 §4).
   */
  addView: (id, viewId) =>
    requestSucceeded(() =>
      apiClient.raw('POST', `${buildAppPath(ENDPOINT)}/${id}/views/add/${viewId}`),
    ),

  removeView: (id, viewId) =>
    requestSucceeded(() =>
      apiClient.raw('DELETE', `${buildAppPath(ENDPOINT)}/${id}/views/remove/${viewId}`),
    ),
};
